import React from 'react';
import formatTime from 'mn-utils/formatTime';
import {
  apiAppRemove,
} from '../../../../../../../api/merchant/app';
import {
  openPopupWindow,
  openPopupInfo,
} from '../../../../../../../emitters/popup';
import WrapperWithLoading from '../../../../../../dumb/WrapperWithLoading/B';
import Popup from '../../../../../../dumb/Popup/B';
import ButtonDecline from '../../../../../../dumb/Button/Decline';
import ButtonRed from '../../../../../../dumb/Button/Red';
import FieldC from '../../../../../../dumb/Field/C';
import Tooltip from '../../../../../../dumb/Tooltip/B';

const {
  getRFC3339,
} = formatTime;


module.exports = (data, callback) => {
  data = data || {};
  const {
    id,
    created_at: createdAt,
  } = data;


  openPopupWindow((setPopupState, popup) => {
    const {
      close,
    } = popup;
    return (stateOfPopup) => {
      return (
        <Popup caption="Are you sure you want to delete this widget credentials?">
          <WrapperWithLoading
            loading={stateOfPopup.loading}
          >
            <div className="cfx mt30 mh-10 (lt|ph10|w1/2|w@m2)>1">
              <FieldC
                label="ID"
                value={id}
              />
              <FieldC
                label="Website"
                value={data.website}
              />
              <FieldC
                label="Created at"
                value={createdAt ? (
                  <Tooltip title={getRFC3339(createdAt)}>
                    {formatTime(createdAt, '{dddd} {mmmm} {dd}, {yyyy} {HH}:{MM}')}
                  </Tooltip>
                ) : '-'}
              />
            </div>
            <div className="cfx mh-10 (lt|ph10|pt20)>1">
              <div>
                <ButtonRed
                  onClick={() => {
                    setPopupState({
                      loading: true,
                    });
                    apiAppRemove({
                      id,
                    }).finally((error) => {
                      setPopupState({
                        loading: false,
                      });
                      if (error) {
                        return;
                      }
                      close();
                      openPopupInfo([`Widget ${id} deleted`]);
                      callback && callback();
                    });
                  }}
                >Delete</ButtonRed>
              </div>
              <div>
                <ButtonDecline
                  onClick={close}
                >Cancel</ButtonDecline>
              </div>
            </div>
          </WrapperWithLoading>
        </Popup>
      );
    };
  });
};
